// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eKG2","delete":"styles_delete__1UP5m","update":"styles_update__BeULZ","add":"styles_add__D4rBM"};